<template>
    <div class="nextleg">
        <p>Zum n&auml;chsten Leg:</p>
        <b-button variant="primary" size="lg" class="mr-2 leg-button" @click="toggleNextLegAutostart"><i :class="['far', autoleg ? 'fa-check-square' : 'fa-square']"></i> Leg Autostart</b-button>
        <b-button
            variant="success"
            size="lg"
            class="leg-button"
            @click="nextLeg"
        >
        <span v-if="!countdownStarted">
            N&auml;chstes Leg starten
        </span>
        <span v-else>
            N&auml;chstes Leg starten in {{countdownTimer}}
        </span>
        </b-button>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                autoleg: false,
                countdown: undefined,
                countdownTimer: 5,
                countdownStarted: false
            }
        },
        mounted() {
            this.autoleg = localStorage.getItem('autoleg') !== null ? JSON.parse(localStorage.getItem('autoleg')) : false;
            this.startcountdown();
        },
        methods: {
            toggleNextLegAutostart() {
                this.autoleg = !this.autoleg;
                localStorage.setItem('autoleg', this.autoleg);
                this.$forceUpdate();
                if (!this.autoleg) {
                    clearInterval(this.countdown);
                    this.countdownStarted = false;
                    this.countdownTimer = 5;
                } else {
                    this.startcountdown();
                }
            },
            nextLeg() {
                this.$emit('nextleg');
            },
            startcountdown() {
                if (!this.autoleg) return; //do not start countdown if autoleg is false
                this.countdownStarted = true;
                this.countdown = setInterval(() => {
                    this.countdownTimer -= 1;
                    if (this.countdownTimer <= 0) {
                        this.nextLeg();
                        clearInterval(this.countdown);
                    }
                }, 1000)
            }
        },

    }
</script>

<style scoped>
    .videoContainer {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
    }

    .leg-button {
        font-size: 2vw;
        margin-top: 1vw;
    }

    .modal-footer {
        display: none;
    }
</style>
